import { ApplicationStatusEnum } from '@app/application/constants';
import { QuestionnaireStatusEnum } from '@app/questionnaire/constants';

export const USER_STATUS_COLOR = {
  [ApplicationStatusEnum.lead as string]: 'info',
  [ApplicationStatusEnum.delivered as string]: 'success',
  [ApplicationStatusEnum.disqualified as string]: 'error',
  [QuestionnaireStatusEnum.applicants as string]: 'info',
  [QuestionnaireStatusEnum.completedIp as string]: 'success',
};

export enum UserRoleEnum {
  superAdmin = 'superAdmin',
  admin = 'admin',
  staff = 'staff',
  surrogate = 'surrogate',
  parent = 'parent',
}

export const INTERNAL_USER_ROLES: UserRoleEnum[] = [UserRoleEnum.superAdmin, UserRoleEnum.admin, UserRoleEnum.staff];

// SAA-79 F14/D14 — the only two sanctioned literal colours in the whole change; no shared palette
// token exists for Staff green or Super Admin purple. Admin uses the theme's secondary.main instead.
export const USER_ROLE_COLOR: Record<string, string> = {
  [UserRoleEnum.admin]: 'secondary.main',
  [UserRoleEnum.staff]: '#95BF2A',
  [UserRoleEnum.superAdmin]: '#9C38B0',
};

export const generalInfoItems = ['firstName', 'lastName', 'phone', 'user.email'] as const;
// SAA-135 slice 3 — `colorCode` renders `priorityTags` (the real Streak-synced column); the item
// name stays the BA's wording and must itself stay out of the questionnaire query's `fields` array.
export const questionnaireGeneralInfoItem = ['contactEmail', 'partner.email', 'colorCode'] as const;

// Admin surrogate detail card only. `generalInfoItems` above is shared with the surrogate's own
// `/profile` page, which reads a `UserData` shape with no bmi/residency/age/priorityTags — editing
// it in place would blank those cells there.
// Color code sits LAST (ruled 2026-08-12), not third as AC2 lists it.
export const adminApplicationGeneralInfoItems = [
  'phone',
  'user.email',
  'bmi',
  'residency',
  'age',
  'priorityTags',
] as const;
